// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".zoho-form-modal{\n    height: 600px;\n    overflow-y: auto;\n}", "",{"version":3,"sources":["webpack://./src/components/ZohoBugModal.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gBAAgB;AACpB","sourcesContent":[".zoho-form-modal{\n    height: 600px;\n    overflow-y: auto;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
